import { render, staticRenderFns } from "./PracticaEjercicios.vue?vue&type=template&id=78cebba4&"
import script from "./PracticaEjercicios.vue?vue&type=script&lang=js&"
export * from "./PracticaEjercicios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports